import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { sub } from 'date-fns';
import es from 'date-fns/locale/es';

registerLocale('es', es);

const DatePickerField = ({
  placeholder,
  value,
  onChange,
  dateFormat = 'dd/MM/Y',
  minDate = new Date(),
  maxDate = sub(minDate, { days: 1 }),
  useMaxDate = false,
  ...otherProps
}) => {
  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      minDate={useMaxDate ? undefined : minDate}
      maxDate={useMaxDate ? maxDate : undefined}
      placeholderText={placeholder}
      dateFormat={dateFormat}
      locale="es"
      className="border-brandblue border-solid border rounded-lg py-2 px-4 w-full text-lg truncate"
      {...otherProps}
    />
  );
};

export const dateTimePicker = (props = {}) => ({
  dateFormat: 'dd/MM/Y h:mm aa',
  showTimeSelect: true,
  showTimeSelectOnly: false,
  timeIntervals: 15,
  ...props,
});

export const onlyTimePicker = (props = {}) => ({
  dateFormat: 'h:mm aa',
  showTimeSelect: true,
  showTimeSelectOnly: true,
  timeIntervals: 15,
  timeCaption: 'Hora',
  ...props,
});

export default DatePickerField;
